module.exports = __webpack_public_path__ + "media/images/pokerroom/888/step4-b5f1f9a7b5019157b284e8932bdd9d6a.jpg";